import React from 'react';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
export function TermsPage() {
  return <div className="min-h-screen" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-468">
      <Navigation data-id="element-469" />

      <div className="pt-32 pb-20 px-4" data-id="element-470">
        <div className="max-w-4xl mx-auto" data-id="element-471">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-472">
            <h1 className="text-4xl sm:text-5xl font-bold mb-6" style={{
            color: 'var(--text-primary)'
          }} data-id="element-473">
              Terms of{' '}
              <span style={{
              color: 'var(--accent)'
            }} data-id="element-474">
                Service
              </span>
            </h1>
            <p className="text-sm mb-8" style={{
            color: 'var(--text-muted)'
          }} data-id="element-475">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>

            <div className="space-y-8" data-id="element-476">
              <Section title="1. Agreement to Terms" data-id="element-477">
                <p data-id="element-478">
                  By accessing or using IT Monsters's services, you agree to be
                  bound by these Terms of Service. If you disagree with any part
                  of these terms, you may not use our services.
                </p>
              </Section>

              <Section title="2. Services Description" data-id="element-479">
                <p data-id="element-480">
                  IT Monsters provides professional web design and development
                  services, including:
                </p>
                <ul data-id="element-481">
                  <li data-id="element-482">Free website demo creation</li>
                  <li data-id="element-483">Custom website design and development</li>
                  <li data-id="element-484">Website hosting setup assistance</li>
                  <li data-id="element-485">30 days of post-launch support</li>
                </ul>
              </Section>

              <Section title="3. Pricing and Payment" data-id="element-486">
                <p data-id="element-487">
                  <strong data-id="element-488">Free Demo:</strong> We provide a free website demo
                  with no obligation. You only pay if you approve the design and
                  want to launch.
                </p>
                <p data-id="element-489">
                  <strong data-id="element-490">Professional Packages:</strong> One-time payment for
                  complete website. Payment required after demo approval before
                  final launch.
                </p>
                <p data-id="element-491">
                  <strong data-id="element-492">Hosting (€10/month):</strong> Optional hosting and
                  maintenance service.
                </p>
                <p data-id="element-493">
                  All prices are in Euros (€). Payments are non-refundable once
                  work has commenced.
                </p>
              </Section>

              <Section title="4. Project Timeline" data-id="element-494">
                <p data-id="element-495">
                  Standard projects are completed within 24 hours from demo
                  approval. Timeline may vary based on:
                </p>
                <ul data-id="element-496">
                  <li data-id="element-497">Project complexity</li>
                  <li data-id="element-498">Client feedback response time</li>
                  <li data-id="element-499">Content availability</li>
                </ul>
              </Section>

              <Section title="5. Revisions and Changes" data-id="element-500">
                <p data-id="element-501">
                  Our package includes 3 rounds of revisions. Additional
                  revisions may incur extra charges. Major scope changes after
                  approval may require additional fees.
                </p>
              </Section>

              <Section title="6. Intellectual Property" data-id="element-502">
                <p data-id="element-503">
                  Upon full payment, you own all rights to the final website
                  design and code. Before payment, all work remains property of
                  IT Monsters.
                </p>
              </Section>

              <Section title="7. Client Responsibilities" data-id="element-504">
                <p data-id="element-505">Clients are responsible for:</p>
                <ul data-id="element-506">
                  <li data-id="element-507">Providing accurate content and materials</li>
                  <li data-id="element-508">Timely feedback and approvals</li>
                  <li data-id="element-509">
                    Domain registration and hosting (if not using our services)
                  </li>
                  <li data-id="element-510">Compliance with applicable laws</li>
                </ul>
              </Section>

              <Section title="8. Limitation of Liability" data-id="element-511">
                <p data-id="element-512">
                  IT Monsters is not liable for indirect, incidental, or
                  consequential damages arising from use of our services. Our
                  total liability is limited to the amount paid for services.
                </p>
              </Section>

              <Section title="9. Termination" data-id="element-513">
                <p data-id="element-514">
                  Either party may terminate the agreement with written notice.
                  Payments for completed work are non-refundable.
                </p>
              </Section>

              <Section title="10. Contact" data-id="element-515">
                <p data-id="element-516">For questions about these Terms, contact us at:</p>
                <p data-id="element-517">
                  Email: legal@itmonsters.agency
                  <br data-id="element-518" />
                  Telegram: @itmonsters
                </p>
              </Section>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer data-id="element-519" />
      <CookieBanner data-id="element-520" />
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="rounded-2xl border p-6 sm:p-8" style={{
    borderColor: 'var(--border)',
    backgroundColor: 'var(--bg-secondary)'
  }} data-id="element-521">
      <h2 className="text-xl sm:text-2xl font-bold mb-4" style={{
      color: 'var(--text-primary)'
    }} data-id="element-522">
        {title}
      </h2>
      <div className="space-y-3 text-sm sm:text-base [&>ul]:list-disc [&>ul]:ml-6 [&>ul]:space-y-2" style={{
      color: 'var(--text-secondary)'
    }} data-id="element-523">
        {children}
      </div>
    </div>;
}